export default {
    PvPgameTitle: "Sweeping Stars Settings",
    gameTitle: "Sweeping Stars",
    topicLabel: "Topic",
    correctItems: "Correct Items",
    correctItemsPlaceholder: "Enter correct words, separated by line breaks or commas (,), press Enter to add",
    errorItems: "Error Items",
    errorItemsPlaceholder: "Enter error words, separated by line breaks or commas (,), press Enter to add",
    gameDuration: "Game Duration",
    second: "seconds",
    saveSettings: "Save Settings",
    startGame: "Start Game",
    pauseGame: "Pause Game",
    resumeGame: "Resume Game",
    gameOver: "Game Over",
    leftSide: "Left Side",
    rightSide: "Right Side",
    leftWins: "Left Side Wins!",
    rightWins: "Right Side Wins!",
    tie: "It's a Tie!",
    playAgain: "Play Again",
    wordExists: "Word already exists, no need to add again",
    maxVocabulary: "Maximum number of correct words reached, please remove some before adding more",
    maxErrorVocabulary: "Maximum number of error words reached, please remove some before adding more",
    topic: "Topic",
    inputTopic: "Please enter topic",
    backgroundSetting: "Background Setting",
    ocean: "Ocean",
    desert: "Desert",
    forest: "Forest",
    gameSpeed: "Game Speed",
    speedSlow: "Slow",
    speedMedium: "Medium",
    speedFast: "Fast",
    
    // Game over screen strings
    win: "Victory",
    items: "",
    wrongItems: "Correct Items",
    maxCombo: "Max Combo",
    showAnswers: "A",
    gamePaused: "Game Paused",
    referenceAnswers: "Reference Answers",
    clearData: "Clear Data",
    sendSuccess: "Game data sent successfully!",
    sendCooldown: "Already sent, please wait 1 minute before operating again",
    pushSuccess: "Game successfully pushed to HiTeach!",
    pushFailed: "Push failed: {message}",
    tokenRefreshing: "Refreshing authorization, please try again later...",
    configLoadSuccess: "Game configuration loaded successfully",
    configLoadFailed: "Load failed (using example configuration)",
    unsubmittedWarning: "Unsubmitted words found in the input field. Please confirm and press Enter before saving!",

    // Dual player mode labels
    leftPlayer: "Left Player",
    rightPlayer: "Right Player",

    // Small screen warning
    smallScreenWarning: "This game is designed for desktop. For the best experience, please use a computer or tablet with a minimum screen size of 1200px*800px",
    currentRank: "Current Rank",
    totalParticipants: "Total Participants",
}